module.exports = __webpack_public_path__ + "img/Philadelphia-Union.87adefec.png";